import { type SvgProps, SvgWrapper } from '../utils';
export function InfoIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z" />
      <path d="M13 12V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z" />
      <path d="M12.0002 9.25C11.3099 9.25 10.7502 8.69035 10.7502 8C10.7502 7.30964 11.3099 6.75 12.0002 6.75H12.01C12.7004 6.75 13.26 7.30964 13.26 8C13.26 8.69035 12.7004 9.25 12.01 9.25H12.0002Z" />
    </SvgWrapper>
  );
}
